<template>
  <div
    class="history-bg"
    style="padding: 0; height: 100%; width: 100%; position: relative"
  >
    <div class="" id="sqTwo" style="height: 100%; width: 100%"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-gl";
export default {
  data() {
    return {
      interVal: "",
      myChart: null,
      app: {
        currentIndex: -1,
      },
      dispatchTimer: null,
      dataLen: null,
    };
  },
  mounted() {
    // this.requestData(500)
    // this.generateRecentWeekDates()
    this.init();
  },
  methods: {
    generateRecentWeekDates() {
      const dates = [];
      const today = new Date();
      // 获取六天前的日期作为起始点
      const startDate = new Date(today);
      startDate.setDate(today.getDate() - 6);

      // 循环7天，逐日递增
      for (let i = 0; i < 7; i++) {
        const currentDate = new Date(startDate);
        currentDate.setDate(startDate.getDate() + i);

        // 格式化为MM-DD
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        dates.push(`${month}-${day}`);
      }

      return dates;
    },
    requestData(number, area, tulongNum, beforeMoney, afterMoney) {
      this.$request(
        "center/newService1/farmLines?num=" +
          number +
          "&area=" +
          area +
          "&tulongNum=" +
          tulongNum +
          "&beforeMoney=" +
          beforeMoney +
          "&afterMoney=" +
          afterMoney
      ).then((res) => {
        if (this.myChart) {
          clearInterval(this.dispatchTimer);
          this.myChart.clear();
        }
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].type == 1) {
            this.init(res.data[i].list);
          }
        }
      });
    },
    init(pageData, type) {
      let that = this;
      that.myChart = echarts.init(document.getElementById("sqTwo"));

      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        that.myChart.resize();
      });
      let data1 = [17.4,19.2,16.5,18.8,17.9,19.6,16.9];
      let data2 = [23.5,25.3,22.7,24.6,23.1,25.8,22.4];
      let data3 = [8, 9, 10.5, 12, 10, 9, 10];
      let data4 = [75, 79, 80, 76, 78, 79, 80];
      let timeData = this.generateRecentWeekDates();

      var option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#021d3a",
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 233,0)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(255, 255, 255,1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 233,0)",
                  },
                ],
                global: false,
              },
            },
          },
          textStyle: {
            color: "#fff",
          },
          //formatter: '{b0}: {c0}<br />{b1}: {c1} KB/s',
          formatter: function (params) {
            //自定义函数修改折线图给数据加单位
            var str = ""; //声明一个变量用来存储数据
            str += "<div>" + params[0].name + "</div>"; //显示日期的函数
            for (var i = 0; i < params.length; i++) {
              // console.log(params[1].seriesName,1111111)
              //图显示的数据较多时需要循环数据，这样才可以成功的给多条数据添加单位
              str +=
                '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
                params[i].color +
                ';"></span>' +
                params[i].seriesName +
                "</span> : <span>" +
                params[i].data +  (params[i].seriesName == '土壤温度' ? '℃' :  "%")
                +
                "</br>";
            }
            return str;
          },
        },
        legend: {
          top: "-0%",
          left: "40%",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          top: "13%",
          left: "5%",
          right: "4%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: true,
            },
            splitArea: {
              // show: true,
              color: "#fff",
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              color: "#fff",
            },
            splitLine: {
              show: false,
            },
            boundaryGap: false,
            data: timeData,
          },
        ],

        yAxis: [
          {
            type: "value",
            min: 0,
            max: 100,
            splitNumber: 6,
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#fff"],
                opacity: 0.6,
              },
            },
            axisLine: {
              show: true,
            },

            axisLabel: {
              show: true,
              margin: 20,
              formatter: "{value}",
              textStyle: {
                fontSize: 14,
                color: "#fff",
              },
            },
            axisTick: {
              show: true,
            },
          },
        ],
        series: [
          {
            name: "土壤湿度",
            type: "line",
            smooth: false, //是否平滑
            showAllSymbol: true,
            //   symbol: 'circle',
            symbolSize: 0,
            lineStyle: {
              normal: {
                color: "#774CFF",
                shadowColor: "rgba(0, 0, 0, 0)",
                shadowBlur: 0,
                shadowOffsetY: 5,
                shadowOffsetX: 5,
              },
            },
            label: {
              show: false,
              position: "top",
              textStyle: {
                color: "#FFF",
                fontSize: 14,
              },
            },
            itemStyle: {
              color: "#774CFF",
              borderColor: "rgb(108,78,0)",
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0)",
              shadowBlur: 0,
              shadowOffsetY: 0,
              shadowOffsetX: 0,
            },
            tooltip: {
              show: true,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [],
                global: false, // 缺省为 false
              },
            },
            data: data1,
          },
          {
            name: "土壤温度",
            type: "line",
            smooth: false, //是否平滑
            showAllSymbol: true,
            // symbol: 'image://./static/images/guang-circle.png',
            //   symbol: 'circle',  //取消注释legend就是实心的
            symbolSize: 0,
            lineStyle: {
              normal: {
                color: "#2FC25B",
                shadowColor: "rgba(0, 0, 0, 0)",
                shadowBlur: 0,
                shadowOffsetY: 5,
                shadowOffsetX: 5,
              },
            },
            label: {
              show: false,
              position: "top",
              textStyle: {
                color: "#fff",
                fontSize: 14,
              },
            },
            itemStyle: {
              color: "#2FC25B",
              borderColor: "rgb(0,115,100)",
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0)",
              shadowBlur: 0,
              shadowOffsetY: 0,
              shadowOffsetX: 0,
            },
            tooltip: {
              show: true,
            },
            data: data2,
          },
          // {
          //   name: "磷",
          //   type: "line",
          //   smooth: false, //是否平滑
          //   showAllSymbol: true,
          //   // symbol: 'image://./static/images/guang-circle.png',
          //   //   symbol: 'circle',  //取消注释legend就是实心的
          //   symbolSize: 0,
          //   lineStyle: {
          //     normal: {
          //       color: "#5B8FF9",
          //       shadowColor: "rgba(0, 0, 0, 0)",
          //       shadowBlur: 0,
          //       shadowOffsetY: 5,
          //       shadowOffsetX: 5,
          //     },
          //   },
          //   label: {
          //     show: false,
          //     position: "top",
          //     textStyle: {
          //       color: "#fff",
          //       fontSize: 14,
          //     },
          //   },
          //   itemStyle: {
          //     color: "#5B8FF9",
          //     borderColor: "rgb(0,115,100)",
          //     borderWidth: 0,
          //     shadowColor: "rgba(0, 0, 0, 0)",
          //     shadowBlur: 0,
          //     shadowOffsetY: 0,
          //     shadowOffsetX: 0,
          //   },
          //   tooltip: {
          //     show: true,
          //   },
          //   data: data3,
          // },
          // {
          //   name: "钾",
          //   type: "line",
          //   smooth: false, //是否平滑
          //   showAllSymbol: true,
          //   // symbol: 'image://./static/images/guang-circle.png',
          //   //   symbol: 'circle',  //取消注释legend就是实心的
          //   symbolSize: 0,
          //   lineStyle: {
          //     normal: {
          //       color: "#FFA729",
          //       shadowColor: "rgba(0, 0, 0, 0)",
          //       shadowBlur: 0,
          //       shadowOffsetY: 5,
          //       shadowOffsetX: 5,
          //     },
          //   },
          //   label: {
          //     show: false,
          //     position: "top",
          //     textStyle: {
          //       color: "#fff",
          //       fontSize: 14,
          //     },
          //   },
          //   itemStyle: {
          //     color: "#FFA729",
          //     borderColor: "rgb(0,115,100)",
          //     borderWidth: 0,
          //     shadowColor: "rgba(0, 0, 0, 0)",
          //     shadowBlur: 0,
          //     shadowOffsetY: 0,
          //     shadowOffsetX: 0,
          //   },
          //   tooltip: {
          //     show: true,
          //   },
          //   data: data4,
          // },
        ],
      };

      that.dataLen = option.series[0].data.length;
      // that.dispatchActions()

      that.myChart.setOption(option);
      // this.interVal = setInterval(function () {
      //     that.myChart.clear()
      //     that.myChart.setOption(option);
      // }, 240000)
      // 20000
    },
    dispatchActions() {
      let that = this;
      that.dispatchTimer = setInterval(function () {
        // 取消之前高亮的图形
        that.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
        //console.log(app.currentIndex);
        // 高亮当前图形
        that.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        // 显示 tooltip
        that.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
      }, 3000);
    },
    clearDispatchTimer() {
      clearInterval(this.dispatchTimer);
    },
    setDispatchTimer() {
      this.dispatchActions();
    },
  },
  destroyed() {
    clearInterval(this.interVal);
  },
};
</script>

<style>
</style>